import OldReportPage from '@/pages/OldReportPage/OldReportPage.vue'

export default OldReportPage
